export const DEFAULT_TEXTS = {
  es: {
    nav_simulate: "Simular",
    nav_benefits: "Beneficios",
    nav_contact: "Contacto",
    hero_eyebrow: "OURIGEN · Resort & Club Vacacional",
    hero_title: "¿Cuánto te costarían tus vacaciones en el futuro con una Membresía?",
    hero_subtitle:
      "Descubre, en menos de un minuto, cuánto puedes ahorrar asegurando hoy tus vacaciones de mañana.",
    cta_start: "Iniciar simulación",
    cta_scroll: "Conoce más",
    q_language: "Selecciona tu idioma",
    lang_es: "Español",
    lang_en: "English",
    q_membership: "¿Tienes una membresía de tiempo compartido o club vacacional?",
    opt_no_membership: "No tengo membresía",
    opt_with_membership: "Ya tengo una membresía",
    q_years: "¿En cuántos años planeas vacacionar en el futuro?",
    q_years_hint: "Considera tu horizonte personal hasta el año final.",
    q_nights: "¿Cuántas noches de hotel por año sueles tomar?",
    q_price: "¿Cuánto pagas actualmente por noche en USD?",
    q_fee: "¿Cuánto pagas actualmente de cuota de mantenimiento al año (USD)?",
    unit_years: "años",
    unit_nights: "noches",
    unit_usd: "USD",
    btn_next: "Continuar",
    btn_back: "Atrás",
    btn_recalc: "Recalcular",
    step: "Paso",
    result_title_a: "Tu proyección al",
    result_title_b: "sin membresía",
    result_title_b_with: "con tu membresía actual",
    result_total_label: "Costo total proyectado",
    result_membership_label: "Con membresía Ourigen estimada",
    result_savings_label: "Ahorro estimado",
    result_disclaimer:
      "Cálculo con inflación compuesta anual. Cifras estimadas en USD.",
    benefits_title: "Por qué elegir tiempo compartido",
    benefits_subtitle:
      "Inmoviliza el costo de tus vacaciones hoy y disfruta de un servicio de hospitalidad de cinco estrellas año tras año.",
    benefit_1_title: "Precio congelado",
    benefit_1_desc:
      "Asegura el costo de tus noches a precio de hoy frente a la inflación hotelera.",
    benefit_2_title: "Experiencia premium",
    benefit_2_desc:
      "Suites de lujo, vista al océano y servicio personalizado en cada visita.",
    benefit_3_title: "Herencia familiar",
    benefit_3_desc:
      "Una membresía que viaja contigo y con las próximas generaciones.",
    contact_eyebrow: "Asesoría privada",
    contact_title: "Habla con un asesor Ourigen",
    contact_subtitle:
      "Déjanos tus datos y un asesor te contactará para diseñar un plan a tu medida.",
    contact_name: "Nombre completo",
    contact_phone: "WhatsApp / Teléfono",
    contact_cta: "Quiero que un asesor me contacte",
    contact_success: "¡Gracias! Un asesor te contactará pronto.",
    contact_error: "Algo salió mal. Inténtalo de nuevo.",
    persuasive_title: "El costo de no actuar hoy",
    persuasive_desc:
      "Cada año que pasa, una noche de hotel cuesta más. Una membresía Ourigen te protege de esa subida y te garantiza el mismo lujo durante décadas.",
    footer_rights: "Todos los derechos reservados.",
    admin_title: "Panel Administrativo",
    admin_email: "Correo",
    admin_password: "Contraseña",
    admin_login: "Iniciar sesión",
    admin_logout: "Cerrar sesión",
    admin_settings: "Configuración",
    admin_leads: "Prospectos",
    admin_texts: "Textos",
    admin_save: "Guardar cambios",
    admin_saved: "Cambios guardados",
    admin_inflation: "Tasa de inflación anual (decimal, ej. 0.045)",
    admin_end_year: "Año final de proyección",
  },
  en: {
    nav_simulate: "Simulate",
    nav_benefits: "Benefits",
    nav_contact: "Contact",
    hero_eyebrow: "OURIGEN · Resort & Sunset V.I.P Membership",
    hero_title: "How much will your vacations cost in the future with Sunset V.I.P Membership?",
    hero_subtitle:
      "Discover, in under a minute, how much you can save by securing tomorrow's vacations today.",
    cta_start: "Start simulation",
    cta_scroll: "Learn more",
    q_language: "Choose your language",
    lang_es: "Español",
    lang_en: "English",
    q_membership: "Do you have a timeshare or vacation club membership?",
    opt_no_membership: "I don't have a membership",
    opt_with_membership: "I already have one",
    q_years: "How many years do you plan to vacation in the future?",
    q_years_hint: "Consider your personal horizon up to the projection year.",
    q_nights: "How many hotel nights per year do you usually take?",
    q_price: "How much do you currently pay per night (USD)?",
    q_fee: "How much do you currently pay yearly in maintenance fees (USD)?",
    unit_years: "years",
    unit_nights: "nights",
    unit_usd: "USD",
    btn_next: "Continue",
    btn_back: "Back",
    btn_recalc: "Recalculate",
    step: "Step",
    result_title_a: "Your projection through",
    result_title_b: "without membership",
    result_title_b_with: "with your current membership",
    result_total_label: "Projected total cost",
    result_membership_label: "Estimated Ourigen membership cost",
    result_savings_label: "Estimated savings",
    result_disclaimer:
      "Calculation with annual compound inflation. Estimated figures in USD.",
    benefits_title: "Why choose timeshare",
    benefits_subtitle:
      "Lock the cost of your vacations today and enjoy five-star hospitality year after year.",
    benefit_1_title: "Price locked",
    benefit_1_desc:
      "Secure tonight's price against decades of hotel inflation.",
    benefit_2_title: "Premium experience",
    benefit_2_desc:
      "Luxury suites, ocean views and personalized service on every visit.",
    benefit_3_title: "Family legacy",
    benefit_3_desc:
      "A membership that travels with you and with future generations.",
    contact_eyebrow: "Private advisory",
    contact_title: "Talk to an Ourigen advisor",
    contact_subtitle:
      "Leave your details and an advisor will reach out to design a plan tailored to you.",
    contact_name: "Full name",
    contact_phone: "WhatsApp / Phone",
    contact_cta: "I want an advisor to contact me",
    contact_success: "Thank you! An advisor will contact you soon.",
    contact_error: "Something went wrong. Please try again.",
    persuasive_title: "The cost of not acting today",
    persuasive_desc:
      "Each year that passes, a hotel night costs more. An Ourigen membership protects you from that rise and guarantees the same luxury for decades.",
    footer_rights: "All rights reserved.",
    admin_title: "Admin Panel",
    admin_email: "Email",
    admin_password: "Password",
    admin_login: "Sign in",
    admin_logout: "Sign out",
    admin_settings: "Settings",
    admin_leads: "Leads",
    admin_texts: "Texts",
    admin_save: "Save changes",
    admin_saved: "Changes saved",
    admin_inflation: "Annual inflation rate (decimal, e.g. 0.045)",
    admin_end_year: "Final projection year",
  },
};
